<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-dark">Sites</h6>
                <a class="btn btn-sm btn-success shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#addModalSite" v-bind:disabled="addSiteProcess || editSiteProcess || deleteSiteProcess"><i class="fas fa-plus fa-md"></i></a>
              </div>
              <div class="card-body">
                <transition name="fade">
                  <div v-if="messageAlert" class="alert p-3" v-bind:class="{ 'alert-success': isSuccess, 'alert-danger': isError }" role="alert">
                    {{messageAlert}}
                  </div>
                </transition>
                <div class="table-responsive">
                  <table class="table table-hover table-bordered" id="dataTableSite" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Pays</th>
                        <th>Ville</th>
                        <th>Nom</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Pays</th>
                        <th>Ville</th>
                        <th>Nom</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </tfoot>
                    <tbody>
                      <tr v-for="(item, index) in sites" v-bind:key="item.id">
                        <td>{{index+1}}</td>
                        <td class="d-none">{{item.id}}</td>
                        <td>{{getPaysName(item.country_id)}}</td>
                        <td>{{item.city}}</td>
                        <td>{{item.name}}</td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-primary shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#viewModalSite" v-on:click="viewSite(item.id)" v-bind:disabled="addSiteProcess || editSiteProcess || deleteSiteProcess">
                          <i class="fas fa-eye fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-warning shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#editModalSite" v-on:click="viewSite(item.id)" v-bind:disabled="addSiteProcess || editSiteProcess || deleteSiteProcess">
                          <i class="fas fa-pencil-alt fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-danger shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#deleteModalSite" v-on:click="viewSite(item.id)" v-bind:disabled="addSiteProcess || editSiteProcess || deleteSiteProcess">
                          <i class="fas fa-trash fa-md"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
    <!-- Add Modal Site -->
    <div class="modal fade" id="addModalSite" tabindex="-1" role="dialog" aria-labelledby="ModalSiteLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="addSiteForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalSiteLabel">Ajouter Site</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-12">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name1" name="name1" required>
                </div>
                <div class="col-sm-6">
                  <label>Pays</label>
                  <select class="custom-select mb-2" v-model=" country_id1" name="country_id1" required>
                    <option v-for="item in countries" v-bind:key="item.id" v-bind:value="item.id">{{item.name}}</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Entreprise</label>
                  <select class="custom-select mb-2" v-model="company_id1" name="company_id1" required>
                    <option v-for="item in companiesSelected1" v-bind:key="item.id" v-bind:value="item.id">{{item.name}}</option>
                  </select>
                </div>
                <div class="col-sm-12">
                  <label>Adresse</label>
                  <textarea class="form-control mb-2" v-model="adresse1" name="adresse1" rows="3" required></textarea>
                </div>
                <div class="col-sm-12">
                  <label>Ville</label>
                  <input type="text" class="form-control mb-2" v-model="city1" name="city1" required>
                </div>
                <div class="col-sm-12">
                  <label>Activités</label>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" v-model="sales_activity1" name="sales_activity1">
                    <label class="form-check-label" for="sales_activity1">Activitè Vente</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" v-model="service_activity1" name="service_activity1">
                    <label class="form-check-label" for="service_activity1">Activitè Après Vente</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" v-model="parts_activity1" name="parts_activity1">
                    <label class="form-check-label" for="parts_activity1">Activitè Pièces</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-success text-uppercase w-50" href="javascript:(0)" v-on:click="addSite" v-bind:disabled="addSiteProcess || editSiteProcess || deleteSiteProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="addSiteProcess">
              Ajouter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- View Modal Site -->
    <div class="modal fade" id="viewModalSite" tabindex="-1" role="dialog" aria-labelledby="ModalSiteLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalSiteLabel">Site [#<span>{{indexSite+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row">Id</th>
                  <td>{{id2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom</th>
                  <td>{{name2}}</td>
                </tr>
                <tr>
                  <th scope="row">Pays</th>
                  <td>{{getPaysName(country_id2)}}</td>
                </tr>
                <tr>
                  <th scope="row">Ville</th>
                  <td>{{city2}}</td>
                </tr>
                <tr>
                  <th scope="row">Adresse</th>
                  <td>{{adresse2}}</td>
                </tr>
                <tr>
                  <th scope="row">Entreprise</th>
                  <td>{{getCompanyName(company_id2)}}</td>
                </tr>
                <tr>
                  <th scope="row">Activitè Vente</th>
                  <td>{{(sales_activity2) ? 'Oui' : 'Non'}}</td>
                </tr>
                <tr>
                  <th scope="row">Activitè Après Vente</th>
                  <td>{{(service_activity2) ? 'Oui' : 'Non'}}</td>
                </tr>
                <tr>
                  <th scope="row">Activitè Pièces</th>
                  <td>{{(parts_activity2) ? 'Oui' : 'Non'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary text-uppercase w-50" href="javascript:(0)" data-dismiss="modal">
            Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Modal Site -->
    <div class="modal fade" id="editModalSite" tabindex="-1" role="dialog" aria-labelledby="ModalSiteLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="editSiteForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalSiteLabel">Modifier Site [#<span>{{indexSite+1}}</span>]</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-12">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name3" name="name3" required>
                </div>
                <div class="col-sm-6">
                  <label>Pays</label>
                  <select class="custom-select mb-2" v-model=" country_id3" name="country_id3" required>
                    <option v-for="item in countries" v-bind:key="item.id" v-bind:value="item.id">{{item.name}}</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Entreprise</label>
                  <select class="custom-select mb-2" v-model="company_id3" name="company_id3" required>
                    <option v-for="item in companiesSelected3" v-bind:key="item.id" v-bind:value="item.id">{{item.name}}</option>
                  </select>
                </div>
                <div class="col-sm-12">
                  <label>Adresse</label>
                  <textarea class="form-control mb-2" v-model="adresse3" name="adresse3" rows="3" required></textarea>
                </div>
                <div class="col-sm-12">
                  <label>Ville</label>
                  <input type="text" class="form-control mb-2" v-model="city3" name="city3" required>
                </div>
                <div class="col-sm-12">
                  <label>Activités</label>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" v-model="sales_activity3" name="sales_activity3">
                    <label class="form-check-label" for="sales_activity3">Activitè Vente</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" v-model="service_activity3" name="service_activity3">
                    <label class="form-check-label" for="service_activity3">Activitè Après Vente</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" v-model="parts_activity3" name="parts_activity3">
                    <label class="form-check-label" for="parts_activity3">Activitè Pièces</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-warning text-uppercase w-50" href="javascript:(0)" v-on:click="editSite" v-bind:disabled="addSiteProcess || editSiteProcess || deleteSiteProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="editSiteProcess">
              Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Delete Modal Site -->
    <div class="modal fade" id="deleteModalSite" tabindex="-1" role="dialog" aria-labelledby="ModalSiteLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalSiteLabel">Supprimer Site [#<span>{{indexSite+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center text-uppercase mt-3">êtes-vous sûr de vouloir supprimer ce site ?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger text-uppercase w-50" href="javascript:(0)" v-on:click="deleteSite" v-bind:disabled="addSiteProcess || editSiteProcess || deleteSiteProcess">
            <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="deleteSiteProcess">
            Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      client: {},
      country: {},
      type: {},
      site: {},
      indexSite: '',
      sites: [],
      countries: [],
      companies: [],
      companiesSelected1: [],
      companiesSelected3: [],
      clients: [],
      types: [],
      isSuccess: true,
      isError: false,
      messageAlert: '',
      addSiteProcess: false,
      viewSiteProcess: false,
      editSiteProcess: false,
      deleteSiteProcess: false,
      name1: '',
      city1: '',
      adresse1: '',
      sales_activity1: '',
      service_activity1: '',
      parts_activity1: '',
      company_id1: '',
      country_id1: '',
      id2: '',
      name2: '',
      city2: '',
      adresse2: '',
      sales_activity2: '',
      service_activity2: '',
      parts_activity2: '',
      company_id2: '',
      country_id2: '',
      name3: '',
      city3: '',
      adresse3: '',
      sales_activity3: '',
      service_activity3: '',
      parts_activity3: '',
      company_id3: '',
      country_id3: '',
      dTableSite: ''
    }
  },
  methods: {
    //Initialiser variables et tables
    init () {
      setTimeout(() => {
        this.dTableSite = $('#dataTableSite').DataTable({
          'columns': [
            { 'width': '15' },
            null,
            null,
            null,
            null,
            { 'width': '100' },
          ],
          'lengthMenu': [
            [10],
            [10]
          ],
          order: [
            [0, 'desc']
          ],
          order: [
            [0, 'desc']
          ],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true
        })
        this.site = {
          id: '',
          code: '',
          name: '',
          internal_code: '',
          site_type: '',
          client: '',
          country: ''
        }
        this.name1 = ''
        this.city1 = ''
        this.adresse1 = ''
        this.sales_activity1 = ''
        this.service_activity1 = ''
        this.parts_activity1 = ''
        this.company_id1 = ''
        this.country_id1 = ''
        this.id2 = ''
        this.name2 = ''
        this.city2 = ''
        this.adresse2 = ''
        this.sales_activity2 = ''
        this.service_activity2 = ''
        this.parts_activity2 = ''
        this.company_id2 = ''
        this.country_id2 = ''
        this.name3 = ''
        this.city3 = ''
        this.adresse3 = ''
        this.sales_activity3 = ''
        this.service_activity3 = ''
        this.parts_activity3 = ''
        this.company_id3 = ''
        this.country_id3 = ''
      }, 50)
    },
    //Sélectionner tous les pays (Base de données)
    getCountries () {
      axios.get(this.apiUrl+'/countries', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.countries = res.data
          this.progress += 1
          if (this.progress === 3) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    getPaysName(countryId) {
          const country = this.countries.find((a) => a.id === countryId);
          return country ? country.name : ''; // Devuelve el nombre o un valor predeterminado
    },
    //Sélectionner tous les sites (Base de données)
    getSites () {
      axios.get(this.apiUrl+'/sites', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.sites = res.data
          this.progress += 1
          if (this.progress === 3) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner toutes les entreprises (Base de données)
    getCompnies () {
      axios.get(this.apiUrl+'/companies', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.companies = res.data
          this.companiesSelected1 = res.data
          this.companiesSelected3 = res.data
          this.progress += 1
          if (this.progress === 3) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    getCompanyName(companyId) {
          const company = this.companies.find((a) => a.id === companyId);
          return company ? company.name : ''; // Devuelve el nombre o un valor predeterminado
    },
    //Ajouter un site
    addSite () {
      if ($('#addSiteForm').isValid()) {
        this.addSiteProcess = true
        let site = {
          id: this.sites.length + 1,
          name: this.name1,
          city: this.city1,
          adresse: this.adresse1,
          sales_activity: this.sales_activity1 ? 1 : 0,
          service_activity: this.service_activity1 ? 1 : 0,
          parts_activity: this.parts_activity1 ? 1 : 0,
          company_id: this.company_id1,
          country_id: this.country_id1
        }
        axios.post(this.apiUrl+'/sites', site, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 201) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement ajouté avec succès'
            this.sites.push(site)
            this.dTableSite.destroy()
            this.init()
          }
          $('#addModalSite').modal('hide')
          this.addSiteProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#addModalSite').modal('hide')
          this.addSiteProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Sélectionner un site (Local)
    viewSite (id) {
      this.site = this.sites.filter(function (item) {
        return item.id === id
      })[0]
      this.indexSite = this.sites.indexOf(this.site)
      this.id2 = this.site.id
      this.name2 = this.site.name
      this.city2 = this.site.city
      this.adresse2 = this.site.adresse
      this.sales_activity2 = this.site.sales_activity
      this.service_activity2 = this.site.service_activity
      this.parts_activity2 = this.site.parts_activity
      this.company_id2 = this.site.company_id
      this.country_id2 = this.site.country_id
      this.name3 = this.site.name
      this.city3 = this.site.city
      this.adresse3 = this.site.adresse
      this.sales_activity3 = this.site.sales_activity
      this.service_activity3 = this.site.service_activity
      this.parts_activity3 = this.site.parts_activity
      this.company_id3 = this.site.company_id
      this.country_id3 = this.site.country_id
    },
    //Modifier un site
    editSite () {
      if ($('#editSiteForm').isValid()) {
        var id = this.site.id
        axios.put(this.apiUrl+'/sites/' + id, {
          name: this.name3,
          city: this.city3,
          adresse: this.adresse3,
          sales_activity: this.sales_activity3 ? 1 : 0,
          service_activity: this.service_activity3 ? 1 : 0,
          parts_activity: this.parts_activity3 ? 1 : 0,
          company_id: this.company_id3,
          country_id: this.country_id3
        }, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status== 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement modifié avec succès'
            this.site.name = this.name3
            this.site.city = this.city3
            this.site.adresse = this.adresse3
            this.site.sales_activity = this.sales_activity3 ? 1 : 0
            this.site.service_activity = this.service_activity3 ? 1 : 0
            this.site.parts_activity = this.parts_activity3 ? 1 : 0
            this.site.company_id = this.company_id3
            this.site.country_id = this.country_id3
            this.sites[this.indexSite] = this.site
            this.dTableSite.destroy()
            this.init()
          }
          $('#editModalSite').modal('hide')
          this.editSiteProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#editModalSite').modal('hide')
          this.editSiteProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Supprimer un site
    deleteSite () {
      var id = this.site.id
      this.deleteSiteProcess = true
      axios.delete(this.apiUrl+'/sites/' + id, {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement supprimé avec succès'
            this.sites.splice(this.indexSite, 1)
            this.dTableSite.destroy()
            this.init()
          }
          $('#deleteModalSite').modal('hide')
          this.deleteSiteProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#deleteModalSite').modal('hide')
          this.deleteSiteProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
    },
    //Sélectionner nom type de site (Local)
    getSiteTypeName (id) {
      this.type = this.types.filter(function (item) {
        return item.id === id
      })[0]
      return this.type.name
    },
    //Sélectionner nom client (Local)
    getClientName (id) {
      this.client = this.clients.filter(function (item) {
        return item.id === id
      })[0]
      return this.client.name
    },
    //Sélectionner nom pays (Local)
    getCountryName (id) {
      this.country = this.countries.filter(function (item) {
        return item.id === id
      })[0]
      return this.country.name
    }
  },
  created () {
    $('body').css({'overflow': 'hidden'})
    this.getCountries()
    this.getSites()
    this.getCompnies()
  },
  watch: {
    loading: function () {
      this.init()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      $('[data-loader="circle-side"]').fadeOut()
      $('#preloader').delay(350).fadeOut('slow')
      $('body').delay(350).css({
        'overflow': 'visible'
      })
    },
    country_id1: function (val) {
      this.companiesSelected1= this.companies.filter(company => company.country_id === val);
      this.company_id1 = ''
    },
    country_id3: function (val) {
      this.companiesSelected3= this.companies.filter(company => company.country_id === val);
      this.company_id3 = ''
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Site.vue